import { ErrorPageHero } from '@modules/error/component/error-page-hero/ErrorPageHero';

const NotFound = () => {
    return (
        <>
            {/* Rendered here rather than in a route's `meta`, because a route
                whose loader threw never has its `meta` called — which is why
                these pages reached the browser with no <title> at all and the
                tab showed the raw URL. React hoists a <title> rendered
                anywhere in the tree into the document head, so the page that
                knows it is a 404 is the one that says so.

                `robots` for the same reason. Non-production environments get
                a blanket noindex from the root route, which made these pages
                look covered; production has no such blanket, so until now a
                404 there carried no directive at all. */}
            <title>Page Not Found | ArchiPro</title>
            <meta name="robots" content="noindex, follow" />
            <ErrorPageHero
                heading="404"
                headingVariant="code"
                description="Sorry, this page has been moved or does not exist."
                cta={{ label: 'Back to Homepage', to: '/' }}
            />
        </>
    );
};

export default NotFound;
